module.exports = __webpack_public_path__ + "img/17.c74f7c85.png";